import React from 'react'
import { ColumnBib, ColumnStartOrder, ColumnNoc, ColumnRank, ColumnName, ColumnResult, ColumnExpander } from "components/common/TableColumns"
import { ColumnTotalPoints, ColumnRound, ColumnRankFinal, ColumnQualificationMark} from "components/sports/sjp/events/individual/resultsFinal/Columns"
import { ColumnBibTeam } from '../../common/TableColumns'

export function TableColumns1RoundLive() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundLiveSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundFinish() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundFinishSM() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}


export function TableColumnsFinalLive() {
    return (
        [
            ColumnRankFinal({ hasIrm: false}),
            ColumnStartOrder({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalLiveSM() {
    return (
        [
            ColumnRankFinal({ hasIrm: false}),
            ColumnStartOrder({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalFinish() {

    return (
        [
            ColumnRankFinal({ hasIrm: false}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalFinishSM() {

    return (
        [
            ColumnRankFinal({ hasIrm: false}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}